import { render, staticRenderFns } from "./PLayout.vue?vue&type=template&id=413e0337&scoped=true&"
import script from "./PLayout.vue?vue&type=script&lang=ts&"
export * from "./PLayout.vue?vue&type=script&lang=ts&"
import style0 from "./PLayout.vue?vue&type=style&index=0&id=413e0337&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413e0337",
  null
  
)

export default component.exports